var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrophoneSlash = function SvgIconMicrophoneSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.998 3.25a2.74 2.74 0 0 0-2 .859 1 1 0 1 1-1.453-1.374A4.74 4.74 0 0 1 12 1.25 4.75 4.75 0 0 1 16.75 6v4.547a1 1 0 1 1-2 0V6A2.75 2.75 0 0 0 12 3.25zm.003-2h.001l-.002 1zM3.827 3.01a1 1 0 0 1 1.413.067L8.988 7.2l.005.005L20.24 19.577a1 1 0 0 1-1.48 1.346l-2.245-2.47A8.5 8.5 0 0 1 13 19.692v2.058a1 1 0 1 1-2 0v-2.058a8.5 8.5 0 0 1-7.5-8.442 1 1 0 1 1 2 0 6.5 6.5 0 0 0 9.641 5.692l-1.222-1.345A4.752 4.752 0 0 1 7.25 11.25V8.262l-3.49-3.84a1 1 0 0 1 .067-1.412m5.423 7.452v.788A2.75 2.75 0 0 0 12 14m-2.75-3.538 3.185 3.503Q12.22 14 12 14",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.25a1 1 0 0 1 1 1 8.5 8.5 0 0 1-.627 3.2 1 1 0 0 1-1.852-.756c.317-.776.48-1.606.479-2.443a1 1 0 0 1 1-1.001"
  }))));
};
export default SvgIconMicrophoneSlash;